<script setup lang="ts">

import { useRouter } from 'vue-router'

const router = useRouter()
const routes = router.options.routes

const navItems = routes.map(route => {
  const slug = route.path === '/' ? 'home' : route.path.replace(/^\//, '')
  const label = route.meta?.title || 'HOME'
  
  return {
    slug,
    label: label as string,
    path: route.path
  }
})
</script>

<template lang="pug">
header.l-header.js-header
  .l-header__bar
  .l-header__inner

    .l-header__logo
      router-link.l-header__logo-link(to="/")
        img.l-header__logo-img(:src="'/common/images/logo.png'" alt="農研機構")
      p.l-header__logo-title 大区画化効果算出アプリ

    nav.l-header__nav
      ul.l-header__nav-list
        li.l-header__nav-item(v-for="item in navItems" :key="item.path" :data-item="item.slug")
          router-link.l-header__nav-link(:to="item.path") {{ item.label }}
</template>
